<template>
  <div>
    <data-prop
      v-for="property of sortedDataProperties"
      :key="property.name.value"
      :dataProperty="property"
      :highlights="highlights"
    ></data-prop>
  </div>
</template>

<script>
import DataProp from '@/components/DataProperty.vue'

const metaPropertyNames = [
  'http://purl.org/dc/terms/created',
  'http://purl.org/dc/terms/modified',
]

export default {
  components: { DataProp },
  props: {
    dataProperties: {
      type: Array,
      default: () => {
        return []
      },
    },
    highlights: {
      type: [String, Array],
      default: () => {
        return []
      },
    },
  },
  computed: {
    sortedDataProperties: function () {
      // TODO crude implementation, refactor, also the meta properties should have created first.
      const metaProperties = this.dataProperties.filter((p) =>
        metaPropertyNames.includes(p.name.value)
      )
      const realProperties = this.dataProperties.filter(
        (p) => !metaPropertyNames.includes(p.name.value)
      )
      return realProperties.concat(metaProperties)
    },
  },
}
</script>
